import * as React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import {black, ButtonBrand, gold, TypographyBrand, white} from '../../../../getLPTheme' 
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider/Divider';
import EditIcon from '@mui/icons-material/Edit';
import { Alert, Collapse, IconButton } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { options } from '@config';
import Loading from '../../../../auxiliares/loading';
import { useAppSelector, useAppDispatch } from '../../../../hooks'
import { varChange } from '../../changeSlice';

export default function ConfiguracionUser ({items}) {

    const [archivo, setArchivo] = React.useState(null);
    const [avatar, setAvatar] = React.useState("../../images/profile.png");
    const [open, setOpen] = React.useState(false);
    const [preview, setPreview] = React.useState(null);
    const [error, setError] = React.useState(false);

    const [openWarning, setopenWarning] = React.useState(false);
    const [openButtons, setopenButtons] = React.useState(true);
    const [openSuccess, setopenSuccess] = React.useState(false);
    const [openProgress, setopenProgress] = React.useState(false);
    const [openError, setopenError] = React.useState(false);
    const [openButtonsSave, setopenButtonsSave] = React.useState(false);
    const fileRef = React.useRef<HTMLInputElement | null>(null);

    const userId = localStorage.getItem("CLUB-VIP-USER")

    const [formData, setFormData] = React.useState({
        user: items.user,
        name: items.name,
        lastname: items.lastname,
        phone: items.phone,
        avatar: items.avatar,
        address: items.address,
        city: items.city,
        province: items.province,
        country: items.country,
        codpostal: items.codpostal,
        notifications: items.notifications
    });

    const dispatch = useAppDispatch()

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {

        setopenProgress(true)

        // Actualiza los datos del usuario
        const response = await fetch((options.api.url + `userid?uid=${userId}`), {
            method: 'PUT',
            mode: "cors",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData),
        });

        setopenProgress(false)

        if (response.status === 200) {
            setopenSuccess(true)
        } else {
            setopenError(true)
        }
    };
    

    React.useEffect(()=>{
        if(localStorage.getItem("CLUB-VIP-AVATAR")){
            setAvatar(localStorage.getItem("CLUB-VIP-AVATAR"));
        }
    }, [])

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleErrorClose = () => setError(false);

    const handleFileSelect = (event) => {
        const archivoSubido = event.target.files[0];
        if (archivoSubido) {
            const fileName = archivoSubido.name.toLowerCase();
            if (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg') || fileName.endsWith('.png')) {
                setArchivo(archivoSubido);
                setPreview(URL.createObjectURL(archivoSubido));
            } else {
                setError(true);
            }
        }
    };

    const handleUploadAvatar = async () => {
        if (!archivo) {
            console.log("Selecciona un archivo primero");
            return;
        }

        const formDataFile = new FormData();
        formDataFile.append('fileAvatar', archivo);
        formDataFile.append('userId', localStorage.getItem("CLUB-VIP-USER"));


        const response = await fetch(options.api.url + "upload", {
            method: 'POST',
            mode: 'cors',
            body: formDataFile
        });

        dispatch(varChange("AvatarnoChange"))

        if (response.status === 200) {
            const data = await response.json();
            console.log("Éxito", data);
            setAvatar(data.imageUrl);
            setFormData({ ...formData, ["avatar"]: data.imageUrl });
            localStorage.setItem("CLUB-VIP-AVATAR", data.imageUrl);
            dispatch(varChange("AvatarChange"))
            handleClose(); 
        } else {
            console.log("Error", response);
        }
    };

    const colorTextField = white[50]
    const paperStyleMedium={height:'100%',width:"100%", alignItems:"center", justifyContent:"center"}
    const btnstyle={margin:'8px 0'}

    return(
        <Box>
            <Container
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                pt: { xs: 2, sm: 2 },
                pb: { xs: 2, sm: 2 },
                height: "auto"
            }}
            >
                <Box 
                    sx={{
                        borderRadius: 2,
                        // bgcolor: white[50],
                        display: { xs: 'flex', md: 'flex' }, 
                        gridTemplateColumns: { md: '1fr 1fr' },
                        padding:1,
                        width: {xs:345, md:600},
                        height:'100%',
                        direction:"column",
                        justifyContent:"center",
                        alignItems:"center",
                        border: 1,
                        borderColor: gold[500]
                    }}
                >
                    <Paper elevation={4} style={paperStyleMedium}>
                        <Box sx={{padding:2, bgcolor:black[1000]}}> 
                            <Typography color={white[50]} sx={{ fontSize: '24px' }}>AJUSTES PERSONALES</Typography>
                            <Divider/>

                            {avatar && (
                                <Grid item xs={7} sx={{ position: 'relative', marginTop: 3, marginBottom: 3 }}>
                                    <Box sx={{ position: 'relative', display: 'inline-block' }}>
                                        <img src={avatar} alt="Avatar" style={{ width: '200px', height: '200px', borderRadius: '50%' }} />
                                        <IconButton
                                            onClick={handleOpen}
                                            sx={{
                                                position: 'absolute',
                                                top: 0,
                                                right: 0,
                                                backgroundColor: white[700],
                                                color: white[50],":hover":{backgroundColor: gold[500],color:black[1000]},
                                                borderRadius: '50%',
                                                padding: '5px',
                                                mr: 4,
                                            }}
                                        >
                                            <EditIcon />
                                        </IconButton>
                                    </Box>
                                </Grid>
                            )}

                            <Grid item xs={7} sx={{marginTop: 1, marginBottom: 1}}>      

                            </Grid>

                            <form onSubmit={handleSubmit}>

                            <Grid container direction="row" justifyContent="center" alignItems="center">
                                <Grid item xs={4}>
                                    <Typography color={white[50]}>
                                        Contraseña
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField name="password" InputLabelProps={{style: { color: colorTextField}}} margin="dense" size="small" label='*******' placeholder='Ingresa tu Contraseña' disabled sx={{pr:1,color: white[50], "& .MuiInputBase-root": {minWidth: 70}, '&:hover': {borderColor: gold[500]}, '& .MuiOutlinedInput-root': {boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50],'&:hover': {borderColor: gold[500], color: white[50]}} }}/>
                                </Grid>
                            
                                <Grid item xs={4}>
                                    <Typography color={white[50]}>
                                        Celular
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>              
                                    <TextField name="phone" InputLabelProps={{style: { color: colorTextField },}} onChange={handleChange} margin="dense" size="small"  defaultValue={items.phone} placeholder='Ingresa tu Celular' disabled={false} sx={{pr:1,color: white[50], "& input.Mui-disabled":{WebkitTextFillColor: white[50]}, "& .MuiInputBase-root.Mui-disabled": {backgroundColor: black[1000]} ,"& .MuiInputBase-root": {minWidth: 70},'&:hover': {borderColor: gold[500]}, '& .MuiOutlinedInput-root': {boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50], '&:hover': {borderColor: gold[500], color: white[50]}} }}/>
                                </Grid>

                                <Grid item xs={4}>
                                </Grid>
                                <Grid item xs={7}>      
                                </Grid>
                                <Grid item xs={1}>
                                </Grid>              
                                <Grid item xs={4}>
                                    <Typography color={white[50]}>
                                        Nombre
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>                 
                                    <TextField name="name" InputLabelProps={{style: { color: colorTextField },}} onChange={handleChange} margin="dense" size="small" defaultValue={items.name} placeholder='Ingresa tu Nombre' disabled={false} sx={{pr:1,color: white[50], "& input.Mui-disabled":{WebkitTextFillColor: white[50]}, "& .MuiInputBase-root.Mui-disabled": {backgroundColor: black[1000]}, "& .MuiInputBase-root": {minWidth: 70}, '&:hover': {borderColor: gold[500]}, '& .MuiOutlinedInput-root': {boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50], '&:hover': {borderColor: gold[500], color: white[50]}} }}/>
                                </Grid>

                                <Grid item xs={4}>
                                    <Typography color={white[50]}>
                                        Apellido
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>                 
                                    <TextField name="lastname" InputLabelProps={{style: { color: colorTextField },}} onChange={handleChange} margin="dense" size="small" defaultValue={items.lastname} placeholder='Ingresa tu Apellido' disabled={false} sx={{pr:1,color: white[50], "& input.Mui-disabled":{WebkitTextFillColor: white[50]}, "& .MuiInputBase-root.Mui-disabled": {backgroundColor: black[1000]}, "& .MuiInputBase-root": {minWidth: 70}, '&:hover': {borderColor: gold[500]}, '& .MuiOutlinedInput-root': {boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50], '&:hover': {borderColor: gold[500], color: white[50]}} }}/>
                                </Grid>

                                <Grid item xs={4}>
                                    <Typography color={white[50]}>
                                        Direccion
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>                 
                                    <TextField name="address" InputLabelProps={{style: { color: colorTextField },}} onChange={handleChange} margin="dense" size="small" defaultValue={items.address} placeholder='Ingresa tu Dirección' disabled={false} sx={{pr:1,color: white[50], "& input.Mui-disabled":{WebkitTextFillColor: white[50]}, "& .MuiInputBase-root.Mui-disabled": {backgroundColor: black[1000]}, "& .MuiInputBase-root": {minWidth: 70}, '&:hover': {borderColor: gold[500]}, '& .MuiOutlinedInput-root': {boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50], '&:hover': {borderColor: gold[500], color: white[50]}} }}/>
                                </Grid>
  
                                <Grid item xs={4}>
                                    <Typography color={white[50]}>
                                        Ciudad
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>                 
                                    <TextField name="city" InputLabelProps={{style: { color: colorTextField },}} onChange={handleChange} margin="dense" size="small" defaultValue={items.city} placeholder='Ingresa tu Ciudad' disabled={false} sx={{pr:1,color: white[50], "& input.Mui-disabled":{WebkitTextFillColor: white[50]}, "& .MuiInputBase-root.Mui-disabled": {backgroundColor: black[1000]}, "& .MuiInputBase-root": {minWidth: 70}, '&:hover': {borderColor: gold[500]}, '& .MuiOutlinedInput-root': {boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50], '&:hover': {borderColor: gold[500], color: white[50]}} }}/>
                                </Grid>
         
                                <Grid item xs={4}>
                                    <Typography color={white[50]}>
                                        Provincia
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>                 
                                    <TextField name="province" InputLabelProps={{style: { color: colorTextField },}} onChange={handleChange} margin="dense" size="small" defaultValue={items.province} placeholder='Ingresa tu provincia' disabled={false} sx={{pr:1,color: white[50], "& input.Mui-disabled":{WebkitTextFillColor: white[50]}, "& .MuiInputBase-root.Mui-disabled": {backgroundColor: black[1000]}, "& .MuiInputBase-root": {minWidth: 70}, '&:hover': {borderColor: gold[500]}, '& .MuiOutlinedInput-root': {boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50], '&:hover': {borderColor: gold[500], color: white[50]}} }}/>
                                </Grid>
         
                                <Grid item xs={4}>
                                    <Typography color={white[50]}>
                                        País
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>                 
                                    <TextField name="country" InputLabelProps={{style: { color: colorTextField },}} onChange={handleChange} margin="dense" size="small" defaultValue={items.country} placeholder='Ingresa tu País' disabled={false} sx={{pr:1,color: white[50], "& input.Mui-disabled":{WebkitTextFillColor: white[50]}, "& .MuiInputBase-root.Mui-disabled": {backgroundColor: black[1000]}, "& .MuiInputBase-root": {minWidth: 70}, '&:hover': {borderColor: gold[500]}, '& .MuiOutlinedInput-root': {boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50], '&:hover': {borderColor: gold[500], color: white[50]}} }}/>
                                </Grid>

                                <Grid item xs={4}>
                                    <Typography color={white[50]}>
                                        Código Postal
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>                 
                                    <TextField name="codpostal" InputLabelProps={{style: { color: colorTextField },}} onChange={handleChange} margin="dense" size="small" defaultValue={items.codpostal} placeholder='Ingresa tu Codigo Postal' disabled={false} sx={{pr:1,color: white[50], "& input.Mui-disabled":{WebkitTextFillColor: white[50]}, "& .MuiInputBase-root.Mui-disabled": {backgroundColor: black[1000]}, "& .MuiInputBase-root": {minWidth: 70}, '&:hover': {borderColor: gold[500]}, '& .MuiOutlinedInput-root': {boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50], '&:hover': {borderColor: gold[500], color: white[50]}} }}/>
                                </Grid>

                                <Grid item xs={4}>
                                    <Typography color={white[50]}>
                                        Email
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>                 
                                    <TextField name="email" InputLabelProps={{style: { color: colorTextField },}} margin="dense" size="small" defaultValue={items.email} placeholder='Ingresa tu Mail' disabled sx={{pr:1,color: white[50], "& input.Mui-disabled":{WebkitTextFillColor: white[50]}, "& .MuiInputBase-root.Mui-disabled": {backgroundColor: black[1000]}, "& .MuiInputBase-root": {minWidth: 70}, '&:hover': {borderColor: gold[500]}, '& .MuiOutlinedInput-root': {boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50], '&:hover': {borderColor: gold[500], color: white[50]}} }}/>
                                </Grid>

                                <Grid item xs={4}>
                                    <Typography color={white[50]}>
                                        Nro. de Documento
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>                 
                                    <TextField name="dni" InputLabelProps={{style: { color: colorTextField },}} margin="dense" size="small" defaultValue={items.dni} placeholder='' disabled sx={{pr:1,color: white[50], "& input.Mui-disabled":{WebkitTextFillColor: white[50]}, "& .MuiInputBase-root.Mui-disabled": {backgroundColor: black[1000]}, "& .MuiInputBase-root": {minWidth: 70}, '&:hover': {borderColor: gold[500]}, '& .MuiOutlinedInput-root': {boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50], '&:hover': {borderColor: gold[500], color: white[50]}} }}/>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography color={white[50]}>
                                        Nro. de Matricula
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>                 
                                    <TextField name="matricula" InputLabelProps={{style: { color: colorTextField },}} margin="dense" size="small" defaultValue={items.matricula} placeholder='' disabled sx={{pr:1,color: white[50], "& input.Mui-disabled":{WebkitTextFillColor: white[50]}, "& .MuiInputBase-root.Mui-disabled": {backgroundColor: black[1000]}, "& .MuiInputBase-root": {minWidth: 70}, '&:hover': {borderColor: gold[500]}, '& .MuiOutlinedInput-root': {boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50], '&:hover': {borderColor: gold[500], color: white[50]}} }}/>
                                </Grid>

                                <Grid item xs={4}>
                                    <Typography color={white[50]}>
                                        Nro de Socio
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>                 
                                    <TextField InputLabelProps={{style: { color: colorTextField },}} margin="dense" size="small" defaultValue={items.numbermembership} placeholder='' disabled sx={{pr:1,color: white[50], "& input.Mui-disabled":{WebkitTextFillColor: white[50]}, "& .MuiInputBase-root.Mui-disabled": {backgroundColor: black[1000]}, "& .MuiInputBase-root": {minWidth: 70}, '&:hover': {borderColor: gold[500]}, '& .MuiOutlinedInput-root': {boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50], '&:hover': {borderColor: gold[500], color: white[50]}} }}/>
                                </Grid>

                                <Box sx={{mt: 2}}>
                                <Grid item xs={12}>
                                    <Collapse in={openButtons}>
                                        <ButtonBrand onClick={() => { setopenButtonsSave(true); handleSubmit()}} color='primary' variant="contained" style={btnstyle} sx={{width: {xs: 200, md:300}}}> Guardar cambios </ButtonBrand>
                                    </Collapse>
                                    <Collapse in={openError}>
                                        <Box sx={{width:"100%", display: "flex", justifyContent:"center", alignItems:"center"}}>
                                            <Alert sx={{ mb: 2 }} severity="error" action={ 
                                                <>
                                                <Grid container direction="row" justifyContent="center" alignItems="center">
                                                    <IconButton aria-label="close" color="inherit" size="small" onClick={() => {setopenError(false)}}> <CloseIcon fontSize="inherit" /> </IconButton> 
                                                </Grid> 
                                                </>}>
                                                Ha ocurrido un error inesperado. Reintente
                                            </Alert>
                                        </Box>
                                    </Collapse>
                                    <Collapse in={openSuccess}>
                                        <Box sx={{width:"100%", display: "flex", justifyContent:"center", alignItems:"center"}}>
                                            <Alert sx={{ mb: 2 }} severity="success" action={ 
                                                <>
                                                <Grid container direction="row" justifyContent="center" alignItems="center">
                                                    <IconButton aria-label="close" color="inherit" size="small" onClick={() => {setopenButtons(true);setopenSuccess(false);}}> <CloseIcon fontSize="inherit" /> </IconButton> 
                                                </Grid> 
                                                </>}>
                                                Sus datos fueron actualizados correctamente
                                            </Alert>
                                        </Box>
                                    </Collapse>
                                    <Collapse in={openProgress}>
                                        <Box sx={{width:"100%", display: "flex", justifyContent:"center", alignItems:"center"}}>
                                            <Loading/>
                                        </Box>
                                    </Collapse>
                                </Grid>
                                </Box>
                            </Grid>
                            </form>  
                            <Divider/>
                        </Box>
                    </Paper>
                </Box>

                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    >
                    <Box
                        sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 400,
                        bgcolor: black[900],
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 4,
                        textAlign: "center",
                        }}
                    >
                        <TypographyBrand id="modal-modal-title" sx={{ fontSize: "1.5rem", mb: 2 }}>
                            Actualizar Avatar
                        </TypographyBrand>

                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 8,
                                color: white[50],
                                ":hover": { backgroundColor: gold[500], color: black[1000] },
                            }}
                        >
                            <CloseIcon />
                        </IconButton>

                        <Divider />

                        {/* Botón seleccionar archivo */}
                        <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
                            <TextField
                                type="file"
                                id="formFile"
                                inputRef={fileRef}
                                InputLabelProps={{ style: { display: "none" } }}
                                onChange={handleFileSelect}
                                sx={{ display: "none" }}
                            />
                            <ButtonBrand onClick={() => fileRef.current?.click()}>
                                Selecciona un archivo
                            </ButtonBrand>                        
                        </Box>

                        {/* Preview */}
                        {preview && (
                        <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
                            <img
                            src={preview}
                            alt="Preview"
                            style={{
                                width: "200px",  
                                height: "200px",
                                borderRadius: "50%",
                                objectFit: "cover",
                            }}
                            />
                        </Box>
                        )}

                        {/* Botón aplicar */}
                        <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
                        <ButtonBrand
                            variant="contained"
                            onClick={handleUploadAvatar}
                            disabled={!archivo}
                            startIcon={<CloudUploadIcon />}
                        >
                            Aplicar
                        </ButtonBrand>
                        </Box>
                    </Box>
                    </Modal>


                <Modal
                    open={error}
                    onClose={handleErrorClose}
                    aria-labelledby="error-modal-title"
                    aria-describedby="error-modal-description"
                >
                    <Box sx={{
                        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                        width: 300, bgcolor: black[900], borderRadius: 2, boxShadow: 24, p: 4
                    }}>
                        <Typography id="error-modal-title" sx={{fontSize: '1.5vw', color: 'red'}}>
                            Error de archivo
                        </Typography>
                        <Typography id="error-modal-description" sx={{ mt: 2, color: white[50] }}>
                            El archivo seleccionado no es válido. Por favor, selecciona un archivo JPG, JPEG o PNG.
                        </Typography>
                        <Box sx={{ marginTop: 2 }}>
                            <ButtonBrand variant="contained" onClick={handleErrorClose} fullWidth>
                                Aceptar
                            </ButtonBrand>
                        </Box>
                    </Box>
                </Modal>
            </Container>
        </Box>
    )
}